angular.module('impactx.navigation').service('PartialDialogsService', PartialDialogsService);

PartialDialogsService.$inject = ['$mdDialog', '$redirect', 'BackService', '$rootScope'];

function PartialDialogsService($mdDialog, $redirect, BackService, $rootScope) {
    const TYPES = {
        USER: 'user',
        COMPANY: 'company',
        CONTRACT: 'contract'
    }
    var lists = {
        user: 'userlist',
        company: 'companylist',
        contract: 'cscontractlist'
    }

    var cache = {};

    function init() {
        cache = {};
        for (var type in TYPES) {
            cache[TYPES[type]] = {};
        }
    }
    init();

    function addNew(type, idBeforeSave, idAfterSave) {
        if(!idBeforeSave && cache.hasOwnProperty(type)) {
            var typed = cache[type];
            if(!typed.hasOwnProperty(idAfterSave)) {
                typed[idAfterSave] = [];
            }
        }
    }

    function setCurrentList(type, listPath) {
        lists[type] = listPath; // overwrite or create new if necessary
    }

    function add(type, id, detail) {
        if(cache.hasOwnProperty(type)) {
            var typed = cache[type];
            if(typed.hasOwnProperty(id)) {
                // add only once, but if the dialog was already done, it still counts as "added"
                if (typed[id].indexOf(detail) < 0) {
                    typed[id].push(detail);
                }
                return true;
            }
        }
        return false;
    }

    function getDoneDialogs(type, id) {
        var result = [];
        if(cache.hasOwnProperty(type)) {
            var typed = cache[type];
            if(typed.hasOwnProperty(id)) {
                result = typed[id];
            }
        }
        return result;
    }

    function redirectToList(type, preSetId) {
        if(lists.hasOwnProperty(type)) {
            var route = "/" + lists[type];

            if (preSetId && preSetId > 0) {
                route = route + "/" + preSetId;
            }

            $redirect.redirectTo(null, route);
        }
        else {
            BackService.back();
        }
    }

    function showDialog(event, type, id, current, preSetId, alwaysShow) {
        if (id) {
            if (add(type, id, current) || alwaysShow) {
                $mdDialog.show({
                    controller: "PartialDialogsDialogCtrl",
                    controllerAs: "partialDialogsDialogCtrl",
                    templateUrl: "shared/navigation/templates/partialdialogs-dialog.tmpl.html",
                    parent: angular.element(document.body),
                    targetEvent: event,
                    clickOutsideToClose: false,
                    locals: {
                        type: type,
                        doneDialogs: getDoneDialogs(type, id)
                    }
                }).then(function (response) {
                    if (response) {
                        $redirect.redirectTo(null, '/' + response + '/' + id);
                    }
                    else {
                        redirectToList(type, preSetId);
                    }
                });
            }
            else {
                redirectToList(type, preSetId);
            }
        }
        else {
            redirectToList(type, preSetId);
        }
    }

    $rootScope.$on('logoutSuccess', function(event) {
        init();
    });

    return {
        TYPE: TYPES,
        addNew: addNew,
        setCurrentList: setCurrentList,
        showDialog: showDialog,
        redirectToList: redirectToList,
        addDialog: add
    }
}